<span class="d-inline-flex lh-1">
    £
    <span class="digit-block">
        <span class="shuffle" id='digit1'>1 2 3 4 5 6 7 8 9 0</span>
    </span>,
    <span class="digit-block">
        <span class="shuffle" id='digit2'>1 2 3 4 5 6 7 8 9 0</span>
    </span>
    <span class="digit-block">
        <span class="shuffle" id='digit3'>1 2 3 4 5 6 7 8 9 0</span>
    </span>
    <span class="digit-block">
        <span class="shuffle" id='digit4'>1 2 3 4 5 6 7 8 9 0</span>
    </span>
</span>